import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { Container } from '../../../Container';
import { AuthSourceLogo } from '../../../AuthSourceLogo';

interface PageErrorGeneralProps {
  error?: { title: string; description: string } | null;
}

export const PageErrorGeneral = ({ error }: PageErrorGeneralProps) => {
  const errorTitle = error ? error.title : 'Неизвестная ошибка';

  const errorText = error ? (
    <span dangerouslySetInnerHTML={{ __html: error.description }} />
  ) : (
    'Упс! Что-то пошло не так'
  );

  return (
    <Container
      theme="general"
      title={
        <Box mb="40">
          <AuthSourceLogo />
        </Box>
      }
    >
      <Box
        bgcolor="bg.light.primary"
        borderColor="stroke.primary"
        border={1}
        py={{ xs: '20', md: '48' }}
        px={{ xs: '20', md: '144' }}
        radius="l"
      >
        <Box mb="32" display="flex" justifyContent="center">
          <Typography variant="h5" align="center">
            {errorTitle}
          </Typography>
        </Box>

        <Box display="flex" justifyContent="center" textAlign="center">
          <Typography variant="body2" color="text.light.secondary">
            {errorText}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};
